import { Subject } from 'rxjs';
import { LabelValueModel } from './labelValue.model';
import { Pipe } from "@angular/core";
import { ContentFormat } from 'app/components/shared/rich-text-editor/rich-text-editor.component';

export type FieldType =
    'text' |
    'longtext' |
    'date' |
    'datetime' |
    'date-picker' |
    'phone' |
    'email' |
    'tel' |
    'currency' |
    'decimal' |
    'number' |
    'address' |
    'boolean' |
    'toggle' |
    'segment' |
    'select' |
    'selects' |
    'contact' |
    'wholesale-contact' |
    'part' |
    'vehicle' |
    'lookup' |
    'lookups' |
    'photo' |
    'image' |
    'url' |
    'path' |
    'html' |
    'inlinehtml' |
    'autocomplete' |
    'autocomplete-company' |
    'signature' |
    'iframe' |
    'stars' |
    'button' |
    'product' |
    'price' |
    'richtext';

export class FieldEvent
{
    detail: FieldModel;
}
export class FieldModel
{

    public valueChanged$: Subject<any> = new Subject<any>();

    public label: string;
    public id: string;
    public value: any;
    public type: string;
    public editable: boolean;
    public required: boolean;
    public selected: boolean;

    //display functions
    public classes: any; //optional classes for display logic
    public sublabel: string; //sublabel bottom left
    public subvalue: string; //subvalue bottom right
    public footernote: string; //subvalue bottom right
    public detail: boolean; //boolean if you want the detail > icon
    public format: string; //output format (eg. number: decimal representation options, specified by a string in the following format: {minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}
    public oneline: boolean;

    //lookup /event object
    public detailObject: any; //the values you want passed through to the (clicked) handler
    public detailClass: string; //used for vehicle class
    public includeNone: boolean; //used for lookup lists
    public noneLabel: string; //used for lookup default label

    //form edit functions
    public dirty: boolean;
    public invalid: boolean;
    public viewInEdit: boolean;
    public hideLabel: boolean;

    //parent field
    public hasChildren: boolean; //if a parent, set to true
    public parent: string; //if child, specify field id
    public parentLookupId: string; //if the parent is set, specify parent GUID

    //reload
    public destroyed: boolean;

    //visible toggle setting
    public toggleEditableWhen: string;
    public toggleVisibleWhen: string;

    //toggle check - invert the check
    public inverseCheck: boolean = false;

    //necessary for nested select lists
    public editValue: string;
    public editCaption: string;

    //debounce
    public debounce: number;

    //boxes for particular select lists
    public showBoxes: boolean;
    public useIdsInInternalLookup: boolean;
    public exclude: string[];  //use this to exclude items eg. "All" from lookups
    public preventParentIdInLookup: boolean; //use this to stop parent id being sent to external lookup

    //segment related
    public disabledSegment: boolean = false; //if true, the segment is disabled and cannot be changed but still shows as edit mode

    //image related
    public showPlaceholder: boolean;
    public disableViewer: boolean;

    //reload from cache
    public clearCache: boolean;

    public errorMessage: string;
    public assistiveText: string;
    public highlightAssistiveText: boolean;

    //rich text
    public richTextFormat: ContentFormat = "html";

    //current text selection 
    public textSelectionStart: number;
    public textSelectionEnd: number
    public textSelectedText: string;

    public calculationField: boolean;
    public calculationOperator: string;
    public calculationFields: string[];


    public hasButton: boolean;
    public buttonText: string;
    public buttonName: string;
    public buttonIcon: string;
    public buttonIonIcon: string;
    public buttonClickedEvent: boolean;
    public buttonIsEndSlot: boolean;

    //expand, shape, fill, size
    public buttonExpand: string;
    public buttonShape: string;
    public buttonFill: string;
    public buttonSize: string;
    public buttonColor: string;

    public launchOnLoad: boolean;

    public allowAdd: boolean;
    public allowAddCode: boolean;
    public allowClear: boolean;
    public forceDisableAllowClear: boolean = false;
    public allowZero: boolean = true;
    public captionCode: string;

    public allowDelete: boolean = false;

    public serverValidationClasses: string;


    /**
     *
     * @param label - label of the field (try to keep this unique)
     * @param value - value of the field
     * @param type - date, number, boolean, string, longtext or array
     * @param id - id for this element
     * @param classes - css classes
     * @param editable - editable boolean
     * @param required - required boolean
     */
    constructor(label: string,
        value: any,
        type: FieldType = "text",
        id: string = "",
        editable: boolean = true,
        required: boolean = false,
        detailObject: any = null,
        classes: string = "",
        detailClass = "",
        viewInEdit: boolean = false,
        errorMessage = '',
        assistiveText = ''
    )
    {
        this.label = label;
        this.id = id;
        if (id = '')
        {
            this.id = label.replace(/\s/g, '');
        }
        this.value = value;
        this.type = type;
        // this.sublabel = sublabel;
        // this.subvalue = subvalue;
        // this.detail = detail;
        // this.format = format;
        this.detailObject = detailObject;
        this.classes = classes;
        this.editable = editable;
        this.required = required;

        this.editValue = value;

        this.detailClass = detailClass;

        this.viewInEdit = viewInEdit;

        this.debounce = 300;

        this.showBoxes = false;

        this.errorMessage = errorMessage;
        this.assistiveText = assistiveText;
        if (assistiveText) console.log(assistiveText);
    }
}
